module.exports = __webpack_public_path__ + "img/signal-strong.637a2e0e.svg";